import { type Component, splitProps } from "solid-js";
import { cn } from "@bso/shared";

type SeparatorProps = {
  class?: string;
  orientation?: "horizontal" | "vertical";
};

const Separator: Component<SeparatorProps> = (props) => {
  const [local, rest] = splitProps(props, ["class", "orientation"]);
  return (
    <div
      role="separator"
      aria-orientation={local.orientation ?? "horizontal"}
      class={cn(
        "shrink-0 bg-accent/20",
        local.orientation === "vertical" ? "h-full w-px" : "h-px w-full",
        local.class,
      )}
      {...rest}
    />
  );
};

export { Separator };
